import { MutationConfig, MutationFunction, useMutation } from "react-query";
import { AxiosRequestConfig } from "axios";
import api from "../index";
import {
  CreateCheckoutSessionBody,
  CreateCheckoutSessionResponse,
} from "types/payments/Checkout";

export const createCheckoutSession = async (
  params: CreateCheckoutSessionBody,
  options?: AxiosRequestConfig,
) => {
  const { data } = await api.post<CreateCheckoutSessionResponse>(
    "/payments/stripe-checkout",
    params,
    options,
  );
  return data;
};

export const useCreateCheckoutSession = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: MutationConfig<
    CreateCheckoutSessionResponse,
    TError,
    { data: CreateCheckoutSessionBody },
    TContext
  >;
  request?: AxiosRequestConfig;
}) => {
  const { mutation: mutationOptions, request: requestOptions } = options || {};

  const mutationFn: MutationFunction<
    CreateCheckoutSessionResponse,
    { data: CreateCheckoutSessionBody }
  > = props => {
    const { data } = props || {};

    return createCheckoutSession(data, requestOptions);
  };

  return useMutation<
    CreateCheckoutSessionResponse,
    TError,
    { data: CreateCheckoutSessionBody },
    TContext
  >(mutationFn, mutationOptions);
};
